<template>
  <v-row no-gutters class="justify-center align-center">
    <v-col cols="auto">
      <permissions-select
        v-model="value"
        :permission-levels="type === 'features_layer' || permission_type === 'three_level' ? 'three' : 'two'"
      />
    </v-col>
  </v-row>
</template>

<script>
import { get } from 'vuex-pathify';

import PermissionsSelect from '@/components/PermissionsSelect';

export default {
  name: 'PermissionsSelectUsers',
  components: {
    PermissionsSelect,
  },
  props: {
    group: {
      type: String,
      required: true,
    },
    id: {
      type: [Number, String],
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    permission_type: {
      type: String,
    },
  },
  data: () => ({}),
  computed: {
    currentGroupPermissions: get('users/currentGroupPermissions'),
    value: {
      get() {
        const key = this.group === 'modules' ? 'module_name' : 'layer_id';
        return this.currentGroupPermissions[this.group].find(permission => permission[key] === this.id).main_value;
      },
      set(nV) {
        const { group, id } = this;
        this.$store.set('users/SET_CURRENT_GROUP_PERMISSIONS_VALUE!', { group, id, valueKey: 'main_value', value: nV });
      },
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(nV) {
        this.$emit('update:value', nV);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .v-input__slot {
    background-color: var(--current-color) !important;
    min-height: 22px !important;
  }
  .v-text-field.v-text-field--solo.v-input--dense > .v-input__control {
    min-height: unset;
  }
  .theme--light.v-select .v-select__selection--comma {
    color: unset;
  }
  .v-input__icon i {
    color: white;
    font-size: 20px;
  }
}
</style>
